import { ChangeDetectionStrategy, Component, output } from '@angular/core';

@Component({
  selector: 'v2-depth-setup',
  imports: [],
  templateUrl: './depth-setup.html',
  styleUrl: './depth-setup.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepthSetupComponent {
  stepComplete = output<boolean>();

  continueToRecommendedCreators(): void {
    this.stepComplete.emit(true);
  }
}
